import { ThunkDispatch } from "core-integration/src/store";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { useDispatch, useSelector } from "react-redux";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import ElementStatus from "../ElementStatus";
import { ElementIconButton } from "../tooltips/ElementIconButton";
import { listWrapper } from "./elementDialogButton.css";
import { ElementDialogButtonProps } from "./types";

const ElementDialogButton = ({
  elementId,
  variant = "list",
}: ElementDialogButtonProps) => {
  const { elementDialogButton: defaults } = usePlosTranslations();
  const dispatch = useDispatch<ThunkDispatch>();

  const elementsById = useSelector(getElementsById);
  const element = elementsById[elementId];

  const actionLabel = defaults.viewPlayerInformation;

  const ariaLabel = element?.news
    ? `${element.news}. ${actionLabel}`
    : actionLabel;

  const content = <ElementStatus element={element} />;

  return (
    <ElementIconButton
      onPress={() => dispatch(showElementSummary(elementId))}
      label={ariaLabel}
    >
      {variant === "list" ? (
        <div className={listWrapper}>{content}</div>
      ) : (
        content
      )}
    </ElementIconButton>
  );
};

export default ElementDialogButton;
